import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Col, Row, UncontrolledTooltip } from 'reactstrap'
import BlockActBtn from '../BlockActBtn'
import RatingIcon from '../RatingIcon'
import './styles.css'

function NewinfoPlacesHeader({
    disableAdminRef,
    cityEmoji={},
    cityName='',
    url='',
    urlBack='',
    title = 'Sin titulo',
    textBtn,
    stars=0,
    small,
    selected,
    modeActCalendar,
    onToggleAct = ()=>{},
    onClose = ()=>{},
    note='',
    onSaveNote=()=>{},
    blockAct,
    onBlockact=()=>{}
}) {
    const {t}= useTranslation()
    const [modeNote, setModeNote] = useState(false)
    const [notemsg, setNotemsg] = useState(note)
    const [isblock, setIsblock] = useState(blockAct)
    //
    return (
        <Row className={`InfoPlacesHeaderCont ${small && 'InfoPlacesHeaderSmallCont'} justify-content-end justify-content-md-between  flex-column-reverse flex-md-row ${modeActCalendar && 'InfoPlacesHeaderContCalendar'}`} >
            <Col md='5' lg='4' className='titleStarsSection mt-1 pr-0'>
            <Row className={`mr-0  mt-3 ${ !small &&  'mb-md-5'} mt-md-0`}>
                <Col className='d-flex justify-content-start align-items-start'>
                    <p className='country '>
                        <div className='emojiCont d-inline-block mr-2'>
                            <img 
                            style={{height:'22px'}} 
                            alt={cityEmoji.emoji} 
                            src={cityEmoji.url}></img>
                        </div>
                    {cityName}</p>
                </Col>
                <Col className='d-flex flex-column justify-content-end align-items-end d-md-none'>
                    {!disableAdminRef && <div className='d-flex starsInfoPlacesCont justify-content-end'  style={{height:'15px'}}>
                        {[1, 2, 3, 4, 5].map((index) => {
                            return (
                            <RatingIcon
                                className='mr-1'
                                width={small? '10px':'13px'}
                                index={index} 
                                rating={stars} 
                                hoverRating={undefined} 
                                onMouseEnter={() => {}} 
                                onMouseLeave={() => {}} 
                                onSaveRating={() => {}} />
                            )
                        })}<span>{stars%1!==0?stars:(`${parseInt(stars)}`).concat(".0")}</span>
                    </div>}
                    <div className='d-flex mt-2'>
                    {modeActCalendar && <>
                                    
                                    <div className='d-flex justify-content-center align-items-center mr-2'>
                                            
                                            <BlockActBtn
                                            style={{position:'relative', fontSize:'10px'}}
                                            isBlock={isblock}
                                            action={()=>{onBlockact(!isblock); setIsblock(!isblock)}}
                                            ></BlockActBtn>
                                    </div>
                                    </>}
                        <div className='openInGoogleMaps position-relative d-md-none' style={{width:'max-content'}}>
                                <a 
                                target='_blank' 
                                rel='noreferrer'
                                href={url}>
                                    <span className=''>
                                        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.1663 6.33333C12.1663 9.27885 9.62929 11.6667 6.49967 13C3.37006 11.6667 0.833008 9.27885 0.833008 6.33333C0.833008 3.38781 3.37006 1 6.49967 1C9.62929 1 12.1663 3.38781 12.1663 6.33333Z" stroke="#106AD4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M8.62467 6.33333C8.62467 7.4379 7.67328 8.33333 6.49967 8.33333C5.32607 8.33333 4.37467 7.4379 4.37467 6.33333C4.37467 5.22876 5.32607 4.33333 6.49967 4.33333C7.67328 4.33333 8.62467 5.22876 8.62467 6.33333Z" stroke="#106AD4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                    <div className='d-md-none d-lg-inline w-100'>{t("seeInMaps")}</div> 
                                </a>
                            </div>
                    </div>
                </Col>
            </Row>
                <Row className={`mt-2 mb-4 titleStarsUrlCont ${modeNote && 'd-none d-md-flex'}`}>
                    <Col xs='12' md='12'>
                    <h2 style={{fontSize: small && '24px', height:(small) && 'auto'}} className='' >{title} </h2>
                    </Col>
                    <Col xs='0' md='12' className='d-none d-md-block'>
                    <Row className=' ml-0 mr-0 justify-content-center align-items-center h-100 flex-column flex-md-row'>
                        <Col className=' pl-md-0'>
                        {!disableAdminRef && <>
                            <div className='d-none d-md-flex starsInfoPlacesCont'  style={{height:'15px'}}>
                            {[1, 2, 3, 4, 5].map((index) => {
                                return (
                                <RatingIcon
                                    className='mr-1'
                                    width={small? '10px':'13px'}
                                    index={index} 
                                    rating={stars} 
                                    hoverRating={undefined} 
                                    onMouseEnter={() => {}} 
                                    onMouseLeave={() => {}} 
                                    onSaveRating={() => {}} />
                                )
                            })}<span>{stars%1!==0?stars:(`${parseInt(stars)}`).concat(".0")}</span>
                                {modeActCalendar && <>
                                    
                                <div className='d-flex justify-content-end align-items-start' style={{marginLeft:'50px'}}>
                                        
                                        <BlockActBtn
                                        style={{position:'relative', fontSize:'10px'}}
                                        isBlock={isblock}
                                        action={()=>{onBlockact(!isblock); setIsblock(!isblock)}}
                                        ></BlockActBtn>
                                        <div id='infoBlocked' className='globeInfo ml-1'><FontAwesomeIcon icon='info'/> </div>
                                        
                                        </div>
                                        
                                        <UncontrolledTooltip className='' autohide={false} placement='bottom-start' target='infoBlocked'>
                                            <div style={{fontSize: '10px'}}>
                                            {t('blockMsg')} 
                                            </div>
                                        </UncontrolledTooltip>
                                </>}
                            </div>
                            </>
                        }
                        </Col>
                        
                    </Row>
                    </Col>
                </Row>
                
                
                    {modeActCalendar ? <Row className='mt-md-3 mr-0 ml-0'>
                        <Col xs={!modeNote ?'6' : '12'} md='12' className='mb-md-4 pl-md-0'>
                            {(!modeNote )? <button type='button' onClick={()=>{setModeNote(true)}} className={`btnAddRemoveAct `}>
                                
                                {notemsg.length===0 ? t('ActivityAddNotes') : t('ActivityEditNotes')}
                            </button> :
                            <div className={`inputNoteAdminCont ${note&& ' inputNoteAdminContBlue'} ` }>
                                <div className='inputNoteAdmin'>
                                    
                                    <textarea placeholder={t('editActPlaceHolder')}
                                    value={notemsg}
                                    onChange={modeNote ? e => {setNotemsg(e.target.value)} : ()=>{}}
                                    ></textarea>
                                    <Row className='justify-content-end m-0'>
                                        <Col xs='6' md='5' lg='4' className='p-0'>
                                            <button type='button' onClick={()=>{
                                                
                                                if(notemsg) {
                                                    onSaveNote('')
                                                }
                                                setModeNote(false);setNotemsg('')
                                                }} className='cancelNoteBtn '>
                                            {!notemsg ? t('signUpCancel'): t('delete')}
                                            </button>
                                        </Col>
                                        <Col xs='6' md='5' lg='4' className='p-0'>
                                            <button disabled={!notemsg} type='button' onClick={()=>{
                                                if(modeNote) {
                                                    setModeNote(false)
                                                    onSaveNote(notemsg)
                                                } else {
                                                    setModeNote(true)
                                                }
                                                }} className={`saveNoteBtn ${note && 'saveNoteBtnBlue'}`}>
                                            {!note ? t('ActivityNotesSave') : t('ActivityNotesEdit')}
                                            </button>
                                        </Col>
                                    </Row>
                                </div>
                            </div>}
                        </Col>
                        <Col xs='6' md='12' className='d-flex  pl-md-0 align-items-center justify-content-center justify-content-md-start'>
                            {!modeNote &&  <button type='button' onClick={onToggleAct} className={`btnAddRemoveAct ${selected && 'removeAct'}`}>
                                
                                {selected ?t('RemoveFromList') : t('addToList')}
                            </button>}
                        </Col>
                    </Row> :
                    <Row>
                        {!small && <Col xs='6' md='12'>
                            <p className='msgAddRemovemsg'>
                                {selected ?t('ActivityRemoveToList') : t('ActivityAddToList')}
                            </p>
                        </Col>}
                        <Col xs='6' md='12' className='d-flex align-items-center justify-content-center justify-content-md-start'>
                            <button type='button' onClick={onToggleAct} className={`btnAddRemoveAct ${selected && 'removeAct'}`} 
                            style={{
                                
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                            }}
                            >
                                {textBtn ? textBtn : <>

                                    {selected ?t('RemoveFromList') : t('addToList')}
                                </>}
                            </button>
                        </Col>
                    </Row>
                    }
                
                
            </Col>
            
            <Col className='mobileMode position-relative' md='6' lg='7'>
            <button onClick={onClose} type='button' className='closeMobileInfo d-md-none'><FontAwesomeIcon color={`${'#001A72'}`} icon='times'/></button>
            <div className='imagenbackHeader' style={urlBack ? {backgroundImage: `url(${urlBack})`} : {}}/>
            </Col>
            
            
        </Row>
    )
}

export default React.memo(NewinfoPlacesHeader)
